export const SET_APP_SECTION = "SET_APP_SECTION";
export const APP_IN_LOADING = "APP_IN_LOADING";
export const APP_SAVE_FILTERS = "APP_SAVE_FILTERS";
export const APP_RESET_FILTERS = "APP_RESET_FILTERS";
